module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.34197df8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-regular-webfont.woff
// module id = 498
// module chunks = 0